module.exports = __webpack_public_path__ + "img/devSearch-default.741d3b7.png";